<template>
  <div class="shuzi">
    <div class="shuzi-top">
      <div class="top-left animate__animated wow animate__fadeInLeft">
        <h2>覆盖医疗企业传统营销多场景</h2>
        <p>赋能药企营销数字化转型、大数据精准营销</p>
        <ul class="btn-card">
          <li><a>科室会</a></li>
          <li><a>学术年会</a></li>
          <li><a>卫星会</a></li>
          <li><a>知识竞赛</a></li>
          <li><a>在线问诊</a></li>
          <li><a>调研问卷</a></li>
          <li><a>病例征集</a></li>
          <li><a>慢病管理</a></li>
          <li><a>科普患教</a></li>
        </ul>
      </div>
      <div class="top-right animate__animated wow animate__fadeInRight">
        <div class="right-box">
          <el-carousel :autoplay="false" indicator-position="none" arrow="never">
            <el-carousel-item v-for="(item,index) in lunboList" :key="index">
              <img :src="item" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="shuzi-main animate__animated wow animate__fadeInUp">
      <div class="title">
        <titleCard title="赋能企业营销数字化转型"></titleCard>
      </div>
      <div class="content">
        <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/D0B15ADA8CCA40FF980C4C61BEF638F1-6-2.png" alt="" class="pcPic">
      </div>
    </div>
    <div class="shuzi-bottom animate__animated wow animate__fadeInUp">
      <div class="title">
        <titleCard title="赋能企业阳光转型"></titleCard>
      </div>
      <div class="content">
        <img src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/72E73D0270DE42689D3A3F11BFC01A7E-6-2.png">
      </div>
    </div>
    <footerCard name="吴老师" phone="138-1097-5144"></footerCard>
  </div>
</template>

<script>
import footerCard from '../../components/footer-card.vue'
import titleCard from '../../components/title-card.vue'
export default {
  data() {
    return {
      lunboList: [
        "https://yyt-ows.oss-cn-beijing.aliyuncs.com/EB4E32D0C5A94B32BC6AA8E825ECAC77-6-2.png",
        // require('../../assets/image/innovatc/lunbo2/lunbo1.webp'),
      ]
    }
  },
  components: {
    footerCard,
    titleCard
  },
  created() {

  },
  mounted() {

  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.shuzi {
  .shuzi-top {
    display: flex;
    // height: 7.4737rem;
    @media screen and (max-width: 540px) {
      flex-wrap: wrap;
    }
    .top-left {
      box-sizing: border-box;
      width: 50%;
      @media screen and (max-width: 540px) {
        width: 100%;
        text-align: center;
        padding: 15px;
        padding-top: 45px;
      }
      padding: 1.5263rem 1.6842rem;
      h2 {
        margin: 0;
        margin-bottom: 0.3158rem;
        font-size: 0.4421rem;
        color: #272b2d;
        font-weight: 700;
        @media screen and (max-width: 540px) {
          font-size: 21px;
        }
      }
      p {
        font-size: 0.2947rem;
        color: #6a7073;
        padding-bottom: 0.6316rem;
        @media screen and (max-width: 540px) {
          font-size: 14px;
          padding-bottom: 25px;
        }
      }
      .btn-card {
        overflow: hidden;
        @media screen and (max-width: 540px) {
          width: 100%;
        }
        li {
          float: left;
          width: 33.3%;
          padding: 0 0.2842rem;
          box-sizing: border-box;
          height: 0.6737rem;
          line-height: 0.6737rem;
          text-align: center;
          margin-bottom: 0.3579rem;
          @media screen and (max-width: 540px) {
            height: 32px;
            line-height: 32px;
          }
          a {
            cursor: pointer;
            display: block;
            border-radius: 0.3368rem;
            background-color: #fbfbfb;
            font-size: 0.2842rem;
            color: #616161;
            font-weight: 300;
            @media screen and (max-width: 540px) {
              height: 100%;
              border-radius: 16px;
              font-size: 14px;
            }
          }
          a:hover {
            background-color: #06aef9;
            color: #fff;
          }
        }
      }
    }
    .top-right {
      width: 50%;
      @media screen and (max-width: 540px) {
        width: 100%;
      }
      display: flex;
      justify-content: center;
      align-items: center;
      .right-box {
        width: 7.7684rem;
        height: 4.3789rem;
        @media screen and (max-width: 540px) {
          width: 80%;
          height: 230px;
        }
        /deep/ .el-carousel__arrow {
          height: 1.7789rem;
          background-color: #06aef9;
          width: 0.7368rem;
          border-radius: 0;
          color: #fff;
          font-size: 0.2737rem;
          @media screen and (max-width: 540px) {
            display: none;
          }
        }
        /deep/ .el-carousel__item {
          img {
            width: 100%;
            height: 100%;
          }
        }
        /deep/ .el-carousel-item {
          width: 100%;
          height: 100%;
        }
        /deep/ .el-carousel__arrow--left {
          left: -0.7368rem;
        }
        /deep/ .el-carousel__arrow--right {
          right: -0.6842rem;
        }
        /deep/ .el-carousel__container {
          width: 6.3158rem;
          margin: 0 auto;
          height: 4.3789rem;
          @media screen and (max-width: 540px) {
            width: 100%;
            height: 230px;
          }
        }
      }
    }
  }
  .shuzi-main {
    height: 11.3684rem;
    width: 100%;
    background: url('https://yyt-ows.oss-cn-beijing.aliyuncs.com/08F068CED38748C2B9A69585B7142BA5-6-2.png') no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 540px) {
      height: 580px;
      background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/B0021A8D00B84327B741E7067E0B0B79-6-2.png") no-repeat;
      background-size: 100% 100%;
    }
    .title {
      padding-top: 1.1158rem;
      padding-bottom: 1.5789rem;
    }
    .content {
      width: 60%;
      margin: 0 auto;
      text-align: center;
      @media screen and (max-width: 540px) {
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;
        img {
          display: none;
        }
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .shuzi-bottom {
    padding-bottom: 1rem;
    .title {
      margin: 1.0526rem 0 0.7895rem 0;
      @media screen and (max-width: 540px) {
        margin-bottom: 56px;
      }
    }
    .content {
      margin: 0 auto;
      height: 6.3158rem;
      width: 12.3158rem;
      @media screen and (max-width: 540px) {
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;
        height: 200px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
